import { useEffect, useState } from 'react';

export interface HeroContent {
  badge: string;
  headline: string;
  subheadline: string;
  trustPoints: string[];
  ctaLabel: string;
  imageUrl: string;
}

export interface StatItem { value: number; suffix: string; label: string; }
export interface ServiceItem { icon: string; colorKey: string; title: string; desc: string; }
export interface StepItem { icon: string; title: string; desc: string; }
export interface ServiceAreaRegion { region: string; areas: string[]; primary?: boolean; }
export interface ContactInfo {
  phone: string;
  email: string;
  address: string;
  serviceArea: string;
  emergencyText: string;
}

export interface SiteSections {
  stats: boolean;
  services: boolean;
  howItWorks: boolean;
  whyUs: boolean;
  serviceAreas: boolean;
  contact: boolean;
}

export interface SiteContent {
  contactInfo: ContactInfo;
  sections: SiteSections;
  hero: HeroContent;
  stats: StatItem[];
  services: ServiceItem[];
  howItWorks: StepItem[];
  whyUs: StepItem[];
  serviceAreas: ServiceAreaRegion[];
}

export function useSiteContent(): { data: SiteContent | null; error: boolean } {
  const [data, setData] = useState<SiteContent | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL ?? ''}/api/v1/public/site-content`)
      .then((r) => r.ok ? r.json() : Promise.reject())
      .then((json) => {
        if (json?.data) setData(json.data);
        else setError(true);
      })
      .catch(() => setError(true));
  }, []);

  return { data, error };
}
